import ApiService from '@/common/api.service'

const RESOURCE = 'page/lp'
const PageLpService = {
  getPreview (code, params) {
    return ApiService.query(`${RESOURCE}/preview/${code}`, params)
  }
}
export default PageLpService
